export default "__VITE_ASSET__BHSJv7Ws__"